/**************************************************
 * Nombre:       Formulario_Valores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {BadgeOutlined} from '@mui/icons-material'
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Valores = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Nombre de la opcion'} dato={'nombre'} {...props}
                                  ejemplo={'Abogado u otro profesional graduado'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoDinero nombre={'Valor'} dato={'valor'} {...props}  />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Valores